import {
	Actions,
	ActionTypes
} from './actions';
import {
	initialState,
	State
} from './state';

export function reducer( state = initialState, action: Actions ): State {
	switch ( action.type ) {
		case ActionTypes.SET_ACTIVE_FORMS:
			return {
				...state,
				error: null,
				activeForms: action.payload
			};
		case ActionTypes.SET_UI_LANGUAGE:
			return {
				...state,
				error: null,
				language: action.payload
			};
		case ActionTypes.SET_MEDIA:
			return {
				...state,
				error: null,
				media: action.payload
			};
		case ActionTypes.SET_COMPACT_NAV_MENU:
			return {
				...state,
				error: null,
				compactNavMenu: action.payload
			};
		case ActionTypes.SHOW_PAGE_LOADER_AND_COUNT_UP:
		case ActionTypes.HIDE_PAGE_LOADER_AND_RESET_COUNTER:
		case ActionTypes.HIDE_PAGE_LOADER_OR_COUNT_DOWN:
			return {
				...state,
				error: null,
				pageLoader: action.payload
			};
		case ActionTypes.SET_UI_EVENT:
			return {
				...state,
				error: null,
				currentUiEvent: action.payload
			};
		default: {
			return state;
		}
	}
}
